import React, { useState, useRef } from "react";

const TextInput = ({ name, value, handleChange, placeholder, isDisabled = false, bgColor= "bg-gray-50", classes = "", type = "text", legend=false, required = false, pattern = undefined, maxLength = undefined }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFieldsetClick = () => {
    if (!isFocused && !value) {
      inputRef.current.focus();
    }
  };

  return (
    legend ? (
    <fieldset
      className={`relative border ${isFocused ? "border-blue-600" : "border-gray-300"} rounded-md w-full border-2 px-2 h-10 flex items-center`}
      onClick={handleFieldsetClick}
    >
      {/* Floating Label (Legend) */}
      <legend
        className={`absolute left-2 transition-all duration-200 ${bgColor} px-1 ` +
          ((type === 'date' && legend)
            ? '-top-3 text-sm text-blue-600'
            : (isFocused || value)
              ? '-top-3 text-sm text-blue-600'
              : 'top-1/2 -translate-y-1/2 text-sm text-gray-400')
        }
      >
        {placeholder || legend} {required && <span className="text-rose-500 ml-1">*</span>}
      </legend>

      <input
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        disabled={isDisabled}
        className={`${classes} w-full border-none h-full outline-none bg-transparent pt-2 px-2`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        ref={inputRef}
        required={required}
        pattern={pattern}
        maxLength={maxLength}
      />
    </fieldset>
    ) : 
    <input 
        type={type}
        name={name} 
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={isDisabled}
        className={`${classes} w-64 border border-gray-300 rounded-[0.3rem] p-1 h-[2.4rem]`}
        required={required}
        pattern={pattern}
        maxLength={maxLength}
    />
  );
};

export default TextInput;